const stateKeys = {
  name: () => `name`,
  startDatetime: () => `startDatetime`,
  endDatetime: () => `endDatetime`,
  items: () => `items`,
  item: () => `item`,
};

export default stateKeys;
